import { useNavigate } from 'react-router-dom';

import { Col, GRID } from '../components/custom';

import firstImage from '../images/perspective/one.webp';
import secondImage from '../images/perspective/two.webp';
import thirdImage from '../images/perspective/three.webp';
import fourthImage from '../images/perspective/four.webp';
import fifthImage from '../images/perspective/five.webp';
import sixthImage from '../images/perspective/six.webp';
import seventhImage from '../images/perspective/seven.webp';
import eigthImage from '../images/perspective/eigth.webp';
import ninthImage from '../images/perspective/nine.webp';

export default function Perspective()
{
    const navigate = useNavigate();

    return (
        <Col id='perspective'>
            <Col className='banner'>
                <span className='title'>Thoughts & Perspectives</span>
                <span className='desc'>Ideas That Challenge. Insights That Lead.</span>
            </Col>
            <GRID>
                <Col onClick={() => navigate('/perspective/declining-nps')}>
                    <img src={firstImage} alt='firstImage'/>
                    <span className='descsmall'>Diagnosing Root Causes Behind a Declining NPS</span>
                </Col>
                <Col onClick={() => navigate('/perspective/analyze-feedback')}>
                    <img src={secondImage} alt='secondImage'/>
                    <span className='descsmall'>Analyzing Customer Feedback on Forums & Review Sites</span>
                </Col>
                <Col onClick={() => navigate('/perspective/feedback-to-advantage')}>
                    <img src={thirdImage} alt='thirdImage'/>
                    <span className='descsmall'>Turn product feedback into your competitive advantage</span>
                </Col>
                <Col onClick={() => navigate('/perspective/employee-disengagement')}>
                    <img src={fourthImage} alt='fourthImage'/>
                    <span className='descsmall'>A Statistical Approach to Understanding Employee Disengagement</span>
                </Col>
                <Col onClick={() => navigate('/perspective/learning-programs')}>
                    <img src={fifthImage} alt='fifthImage'/>
                    <span className='descsmall'>Evaluating the Effectiveness of Learning Programs</span>
                </Col>
                <Col onClick={() => navigate('/perspective/declining-engagement')}>
                    <img src={sixthImage} alt='sixthImage'/>
                    <span className='descsmall'>Diagnosing What's Behind Declining Engagement</span>
                </Col>
                <Col onClick={() => navigate('/perspective/segmenting-customers')}>
                    <img src={seventhImage} alt='seventhImage'/>
                    <span className='descsmall'>Segmenting Customers by Experience Preferences</span>
                </Col>
                <Col onClick={() => navigate('/perspective/cx-trends')}>
                    <img src={eigthImage} alt='eigthImage'/>
                    <span className='descsmall'>Monitoring CX Trends Over Time</span>
                </Col>
                <Col onClick={() => navigate('/perspective/support-team')}>
                    <img src={ninthImage} alt='ninthImage'/>
                    <span className='descsmall'>Measuring the Impact of Support Team Training</span>
                </Col>
            </GRID>
        </Col>
    )
}